
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Urbanización El Coto</h3>
            <p className="text-sm">
              Trabajando por el futuro de nuestra urbanización en El Casar,
              Guadalajara
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:underline">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/equipo" className="text-sm hover:underline">
                  Equipo Gestor
                </Link>
              </li>
              <li>
                <Link to="/planes" className="text-sm hover:underline">
                  Planes y Logros
                </Link>
              </li>
              <li>
                <Link to="/votar" className="text-sm hover:underline">
                  Cómo Votar
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <p className="text-sm">
              Email: marandrada@gmail.com
              <br />
              Dirección: El Casar, Guadalajara
            </p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-white/10 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Urbanización El Coto. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
